<tt-page *ngIf="page">
    <tt-card *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="editSeller"></ng-container>
    </tt-card>

    <tt-card *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery" [ttHeading]="sellerId === '0' ? 'h_seller_new' : 'h_seller_edit'">
        <ng-container *ngTemplateOutlet="editSeller"></ng-container>
    </tt-card>
</tt-page>

<ng-template #editSeller>
    <ng-container *ngIf="!!page">
        <tt-input ttLabel="seller_id" [(ttModel)]="page.seller_id" [ttReadonly]="sellerId !== '0'"></tt-input>
        <tt-checkbox ttLabel="islabourer" [ttModel]="page.labour_no === '0' ? '0' : '1'" ttReadonly></tt-checkbox>
        <tt-search ttLabel="seller_name" [ttModel]="page.seller_name" (ttModelChange)="onSearchChange($event)" [ttSearch]="sellerSearch" ttDataId="labour_no" ttDataName="labour_keyname" (ttOnSelected)="selectSeller($event)" (ttOnClear)="selectSeller()"></tt-search>
        <tt-select ttLabel="businessco" [(ttModel)]="page.businessco_no" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-checkbox ttLabel="isactive" [(ttModel)]="page.isactive"></tt-checkbox>
        <tt-button-save ttText="seller_save" [ttLoading]="saving" (ttClick)="saveChanges()" ttTextAlign="center"></tt-button-save>
    </ng-container>
</ng-template>
